import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

export var FigureWrapper = /*#__PURE__*/_styled("div", true ? {
  target: "e9jjrbn0"
} : {
  target: "e9jjrbn0",
  label: "FigureWrapper"
})(true ? {
  name: "5ogka4",
  styles: "margin:64px 0"
} : {
  name: "5ogka4",
  styles: "margin:64px 0",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvUmljaFRleHQvRmlndXJlLnZpZXdzLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFdUMiLCJmaWxlIjoiL3dvcmtkaXIvbGlicy9tYXRjaGEvcmVjaXBlcy9SaWNoVGV4dC9GaWd1cmUudmlld3MudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5cbmV4cG9ydCBjb25zdCBGaWd1cmVXcmFwcGVyID0gc3R5bGVkLmRpdmBcbiAgbWFyZ2luOiA2NHB4IDA7XG5gXG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});